import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useStore } from "../store/store-context";
import { useStateInRef } from 'seagull';
import { usePusher } from "./PusherProvider";
const PusherBusinessChannelContext = /*#__PURE__*/React.createContext({
  getChannel() {}
});
export const usePusherBusinessChannel = () => useContext(PusherBusinessChannelContext);

/** Responsible for subscribing/unsubscribing to the pusher business channel. */
export function PusherBusinessChannelProvider(props) {
  const pusher = usePusher();
  const userInfo = useStore(state => state.userInfo);
  const businessId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessId();
  const [channelBusinessId, setChannelBusinessId] = useState();
  const getChannelBusinessId = useStateInRef(channelBusinessId);
  useEffect(() => {
    const shouldSubscribe = !!businessId;
    if (!shouldSubscribe) return;
    pusher.subscribe(businessId);
    setChannelBusinessId(businessId);
    return () => {
      pusher.unsubscribe(businessId);
      setChannelBusinessId(undefined);
    };
  }, [businessId]);
  const getChannel = useCallback(() => {
    const bid = getChannelBusinessId();
    return bid ? pusher.channel(bid) : undefined;
  }, []);
  const value = useMemo(() => {
    return {
      getChannel,
      channelBusinessId
    };
  }, [getChannel, channelBusinessId]);
  return /*#__PURE__*/React.createElement(PusherBusinessChannelContext.Provider, {
    value: value
  }, props.children);
}